import { MessageTemplateServicePromiseClient } from "@/pb/scout/message_template/v1/message_template_grpc_web_pb";
import { RpcError } from "grpc-web";
import { handleGrpcError } from "@/grpc-web/utils";
import {
  GetAllOrderByUpdatedAtRequest,
  CreateRequest,
  UpdateRequest,
  DeleteRequest
} from "@/pb/scout/message_template/v1/message_template_pb";

const client: MessageTemplateServicePromiseClient = Object.assign(
  new MessageTemplateServicePromiseClient(
    process.env.VUE_APP_SCOUT_GRPC_ORIGIN,
    null,
    {
      withCredentials: true
    }
  )
);

export const getAllMessageTemplates = async () => {
  const request = new GetAllOrderByUpdatedAtRequest();

  const response = await client
    .getAllOrderByUpdatedAt(request)
    .catch((e: RpcError) => {
      handleGrpcError(e);
      throw e;
    });

  return response.getMessageTemplatesList();
};

export const createMessageTemplate = async (name: string, body: string) => {
  const request = new CreateRequest();
  request.setName(name);
  request.setBody(body);

  const _ = await client.create(request).catch((e: RpcError) => {
    handleGrpcError(e);
    throw e;
  });

  return null;
};

export const updateMessageTemplate = async (
  id: number,
  name: string,
  body: string
) => {
  const request = new UpdateRequest();
  request.setId(id);
  request.setName(name);
  request.setBody(body);

  const _ = await client.update(request).catch((e: RpcError) => {
    handleGrpcError(e);
    throw e;
  });

  return null;
};

export const deleteMessageTemplate = async (id: number) => {
  const request = new DeleteRequest();
  request.setId(id);

  const _ = await client.delete(request).catch((e: RpcError) => {
    handleGrpcError(e);
    throw e;
  });

  return null;
};
